import { _LOADING } from '../actions/types';
const DEFAULT_STATE = {
    loading: false
};

const errorReducer = (state=DEFAULT_STATE, action) => {
    switch (action.type) {
        case _LOADING:
            return  {...state, loading: action.payload};
        default:
            return state;
    }
};

export default errorReducer;